<template>
    <my-popup title="选择优惠券链接" width="1050" :flag="isShow" @close="popupClose" zIndex='100000'>
        <div class="insert-coupon">
            <!-- 头部查询 -->
            <div class="couponHead">
                <div class="item">
                    <span>优惠券名称：</span>
                    <el-input v-model="param.name" placeholder="请输入优惠券名称" style="width:200px;"></el-input>
                </div>
                <div class="item">
                    <span>状态：</span>
                    <el-select v-model="param.deleted" placeholder="请选择" style="width: 200px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未关闭" :value="0"></el-option>
                        <el-option label="已关闭" :value="1"></el-option>
                    </el-select>
                </div>
                <button class="searchBtn" @click="handleSearch">
                    <i class="el-icon-search" style="fontSize: 14px;  marginRight: 4px;"></i>查询
                </button>
                <button class="resetBtn" @click="handleReset">重置</button>
            </div>
            <!-- 创建优惠券 --> 
            <div class="createCoupon">
                <button class="createBtn" @click="open">
                    <img src="../../assets/images/add_icon32.png" class="addIcon">
                    创建优惠券 
                </button>
                <button class="updateBtn" @click="getDataList">更新</button>
            </div>
            <!-- nav导航 表格数据 -->
            <div class="navTableWrapper">
                <div class="navTab">    
                    <span :class="{'active': param.bindType == 1}" @click="handleSwitch(1)">店铺券</span>
                    <span :class="{'active': param.bindType == 2}" @click="handleSwitch(2)">商品券</span>
                    <div class="line"></div>
                </div>
                
                <div class="tableWrapper">
                    <el-table
                        :data="tableData"
                        @sort-change="sortChange"
                        v-loading="tableLoading"
                        :default-sort = "{prop: 'num', order: 'ascending'}"
                        style="width: 100%;border: 1px solid #e6e6e6;">

                        <el-table-column prop="name" label="优惠券名称" width="160"></el-table-column>
                        <el-table-column prop="discount" label="面额" width="80"></el-table-column>
                        <el-table-column prop="quota" label="门槛"></el-table-column>

                        <el-table-column label="活动时间" width="220">
                            <template slot-scope="scope">
                                <div class="time">
                                    <span>起: {{scope.row.beginTime}}</span>
                                    <span>止: {{scope.row.endTime}}</span>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="num" label="发行量" sortable='custom'></el-table-column>
                        <el-table-column prop="sendNum" label="领取量"></el-table-column>
                        <el-table-column prop="usedNum" label="使用量" sortable='custom'></el-table-column>

                        <el-table-column prop="deleted " label="状态" >
                            <template slot-scope="scope">
                                <p>{{+scope.row.deleted === 1 ? '已关闭' : '未关闭'}}</p>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <button class="getLink" @click="getLink(scope.$index, scope.row)">获取链接</button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </div>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                class="pagination"
                :total="total">
            </el-pagination>
        </div>
    </my-popup>
</template>

<script>
import {coupons} from '@/api/wareController'
import myPopup from '../../components/myPopup'

export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        }
    },
    components: {
        myPopup
    },
    data() {
        return {
            couponNameValue: null,
            couponSelectValue: null,
            param: {
              size: 10,
              current: 1,
              name: '',
              bindType: 1, // 1.全店参加 2.指定sku
              deleted: 0, // 0.未关闭 1.已关闭
              orderType: 'num', // 排序字段 num发行量 usedNum使用量
              orderDirection: 'asc', // 排序规则 asc升序排序 desc降序排序
            },
            total: 0,
            tableLoading: false,
            // tab选中
            navIsAcitev: 1,
            // 表格数据
            tableData: [],
            // 当前页
            currentPage: 1
        }
    },
    created() {
        this.getDataList();
    },
    methods: {
      /*
     * 创建优惠券事件
     * */
    open() {
       window.open(
          "https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fprom.shop.jd.com%2Frest%2Fshop%2Fcoupon%2Findex"
        );
        // this.$alert(
        //   "由于淘宝优惠券限流，可将在淘宝后台创建的领取型优惠券，通过短信嵌入领取链接的方式发送给买家，引导买家领取优惠券。",
        //   "温馨提示",
        //   {
        //     confirmButtonText: "去后台创建优惠券",
        //     callback: action => {
        //       // this.$message.info(`action: ${action}`);
        //       if (action == "confirm") {
        //         window.open(
        //           "https://aliyx.taobao.com/coupon/create?couponType=0#/?_k=kddjv4"
        //         );
        //       }
        //     }
        //   }
        // );

        // console.log(
        //   "https://aliyx.dist.com/coupon/create?spm=a21y7.9633641.0.0.3ac86658QQ7bNr&couponType=0#/?_k=m9e8oz   "
        // );
      },

      sortChange(column, prop, order) {
        // console.log(column, prop, order)
        this.param.orderType = prop;
        if (order == 'descending') {
          this.param.orderDirection = 'desc'
        }else {
          this.param.orderDirection = 'asc'
        }
        this.getDataList();
      },
      handleSwitch(type) {
        this.param.name = '';
        this.param.deleted = 0;

        this.param.bindType = type;
        this.param.size = 10;
        this.param.current = 1;
        this.getDataList();
      },

      // 重置
      handleReset() {
        this.param.name = '';
        this.param.deleted = 0;
        this.getDataList();
      },

      handleSearch() {
        this.getDataList();
      },

      // 获取优惠券列表
      getDataList() {
        this.tableLoading = true;
        coupons(this.param).then(res => {
          this.tableLoading = false;
          // console.log('res777:', res)
          if (res.code == '1') {
            this.tableData = res.data.records;
            this.total = +res.data.total;
          }
        })
      },

      // 关闭弹窗
      popupClose() {
          this.$emit('close', false);
      },
      /**
       * 获取链接
       */
      getLink(_ind,_item) {
          this.$emit('close', true, _item);
      },
      /**
       * 分页事件
       */
      handleSizeChange(val) {
        this.param.size = val;
        this.getDataList();
      },
      handleCurrentChange(val) {
        this.param.current = val;
        this.getDataList();
      },
    },
}
</script>

<style scoped lang="scss">
.insert-coupon {
    button {
        border: none;
        background-color: white;
        outline: none;
        padding: 0;
        margin: 0;
        border-radius:3px;
        cursor: pointer;
    }
    .couponHead {
        display: flex;
        align-items: center;
        height: 72px;
        .item {
            margin-right: 80px;
            &:last-child {
                margin: 0;
            }
        }
        button {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .searchBtn{
            width: 98px;
            height: 32px;
            margin-right: 8px;
            border:1px solid rgba(254,77,69,1);
            color: #FE4D45;
        }
        .resetBtn {
            width: 98px;
            height: 32px;
            border:1px solid rgba(0,0,0,0.14901960784313725);
            color: #000000;
        }
    }
    .createCoupon {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .createBtn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 112px;
            height: 32px;
            line-height: 33px;
            margin-right: 16px;
            background-color: #FE4D45;
            color: #fff;
            .addIcon {
                width: 14px;
                height: 14px;
                margin-right: 4px;
            }
        }
        .updateBtn {
            width: 98px;
            height: 32px;
            line-height: 32px;
            border:1px solid rgba(0,0,0,0.14901960784313725);
            color: #000;
            text-align: center;
        }
    }
    .navTableWrapper {
        .navTab {
            display: flex;
            align-items: flex-end;
            width: 100%;
            height: 35px;
            margin: 20px 0;
            span {
                flex-shrink: 0;
                width: 106px;
                height: 35px;
                line-height: 34px;
                text-align: center;
                margin-right: 2px;
                border:1px solid rgba(221,221,221,1);
                border-radius:2px 2px 0px 0px;
                cursor: pointer;
                &:last-child {margin: 0;}
            }
            .active {
                border-bottom: none !important;
                border-top: 2px solid #FE4D45;
                border-radius: 4px 4px 0px 0px;
            }
            .line {
                flex: 1;
                border-bottom: 1px solid #DDD;
            }
        }
        .tableWrapper {
            max-height: 400px;
            overflow: auto;
            .time {
                display: flex;
                flex-direction: column;
                line-height: 20px;
            }
            .getLink {
                padding-left: 0 !important; 
                font-size: 14px; 
                color:#FE4D45;
                background-color: #f5f7fa25;
                &:hover {
                    background-color: #F5F7FA;
                }
            }
            &::-webkit-scrollbar {
                width:8px;
                height:10px;
            }
            &::-webkit-scrollbar-track {
                background:rgba(246,246,246,1);
                border-radius: 2px;
            }
            &::-webkit-scrollbar-thumb {
                background: #ddd;
                border-radius:10px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #ddd;
            }
            .table-message {
                display: inline-block;
                vertical-align: middle;
                cursor: pointer;
                color: #FE4D45;
                font-weight: 400;
            }
            .hoveTitle {
                text-align: left;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    .pagination {
        margin-top: 20px;
        text-align: right;
    }
}
</style>